var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcheryMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.375,
    height: 108.255,
    viewBox: "0 0 108.375 108.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5176",
    "data-name": "Rectangle 5176",
    width: 108.375,
    height: 108.255,
    rx: 20,
    transform: "translate(247.625 649.255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5175",
    "data-name": "Rectangle 5175",
    width: 140.239,
    height: 140.084,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_105",
    "data-name": "Mask Group 105",
    transform: "translate(-247.625 -649.255)",
    opacity: 0.16,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13242",
    "data-name": "Group 13242",
    transform: "translate(125.921 524.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13241",
    "data-name": "Group 13241",
    transform: "translate(121.704 124.567)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45520",
    "data-name": "Path 45520",
    d: "M74.538.152a68.9,68.9,0,0,0-31.7,5.391C40.45,6.553,35.319,8,36.384,11.335c1.173,3.674,6.455-.186,8.423-1.008C90.161-8.61,140.981,28,134.91,77.11c-4.648,37.6-35.619,61.484-73.4,57.074C20.158,129.358-4.881,86.115,9.376,47.519c.79-2.139,3.262-6.3,3.611-7.969.5-2.4-1.188-4.279-3.611-3.286-1.64.672-4.4,7.972-5.1,9.92C-14.465,98.641,31.239,150.154,85.7,138.389,163.8,121.516,156.211,5.518,74.538.152",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45521",
    "data-name": "Path 45521",
    d: "M105.473,54.063a46.912,46.912,0,0,0-21.987,3.513c-2.224.92-7.85,2.8-5.486,6.081,1.8,2.5,5.457-.484,7.458-1.3,41.367-16.842,78.172,33.323,48.458,67.128-31.621,35.975-89.236-.279-71.176-44.455.768-1.88,4.425-6.992.453-7.859-2.282-.5-3.118,1.347-4.017,3.052-17.017,32.307,9.621,71.169,45.76,68.813,58.778-3.831,59.281-90.588.536-94.976",
    transform: "translate(-31.564 -31.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45522",
    "data-name": "Path 45522",
    d: "M174.427,22.576l-11.373.689c-2.381.921-2.711,3.128-1.013,4.945,6.281,6.022,12.134,12.544,18.666,18.274,4.448.465,8.973-.606,13.447-.624l31.8,31.771A2.658,2.658,0,0,0,229.591,74L197.757,42.264l.808-10.45c.086-2.259.161-2.681-1.258-4.4a172.866,172.866,0,0,0-17.076-17.045c-1.936-1.543-3.426-1.907-4.941.4a105.834,105.834,0,0,0-.863,11.8M192.6,40.715c-3.345-.122-6.712.814-10.023.461-1.209-1.858-12.827-11.909-12.846-12.816-.029-1.383,8.784,1.044,9.635-3.2.392-1.953.162-4.292.371-6.2.034-.315.15-1.08.485-1.073.908.019,10.98,11.615,12.841,12.821.353,3.305-.584,6.666-.462,10",
    transform: "translate(-156.981 -5.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45523",
    "data-name": "Path 45523",
    d: "M135.309,107.976c-2.621-.267-10.861-.361-12.244,2.293a2.588,2.588,0,0,0,.592,3.394c1.61,1.153,6.6-.774,8.923-.775,14.193-.007,23.294,14.676,18.257,27.6-8.176,20.982-41.861,13.245-38.074-11.1.272-1.752,2.064-4.851-.471-5.942-3.784-1.628-4.735,3.944-4.932,6.491-1.436,18.615,14.663,32.253,32.823,26.817,25.352-7.588,21.984-46.048-4.874-48.777",
    transform: "translate(-62.024 -62.789)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcheryMob);
export default __webpack_public_path__ + "static/media/archery_mob.fef63f1f3457372870d6a9434fb9792b.svg";
export { ForwardRef as ReactComponent };